import UiSaveButtons from 'global/components/buttons/UiSaveButtons';
import FullPageWrapper from 'global/wrappers/FullPageWrapper';
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares';
import _ from 'lodash';
import { useTeamRosters } from 'projectSpecific/sports/useHelpers/useTeamRosters';
import { useContext, useEffect, useMemo, useReducer, useState } from 'react';
import { Icon, Label } from 'semantic-ui-react';
import { ParentContext } from '../../../../global/cnr/contexts/ParentContext';
import { sidebarHandlers, sidebarInitialState, sidebarReducer } from '../../../../global/cnr/reducers/SidebarReducer';
import { gEnums } from '../../../../global/enums/globalEnums';
import Wrapper, { wrapperTypes } from '../../../../global/wrappers/Wrapper';
import { GolfTournamentContext } from '../../../golf/cnr/contexts/GolfTournamentContext';
import { SportsEditMatchContext } from '../../cnr/contexts/SportsEditMatchContext';
import { SportsMatchContext } from '../../cnr/contexts/SportsMatchContext';
import { SportsSeasonContext } from '../../cnr/contexts/SportsSeasonContext';
import { CreateSportsContext } from '../../create/CreateSports';
import NoData from 'global/components/alerts/NoData';

const sidebarType = 'sportsAthletes'

const SportsAthletes = (props) => {

  const _asat = gEnums.availableSubActionTypes
  const { isFullPage, handleCancel, componentContexts, subActionType, displayType, sportsDisplayType: sportsDisplayType_prop } = props ?? {}

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states, fn_cls } = parentContext ?? {}
  const { eventInfo_state, paps_state } = states

  // componentContexts
  const { uiItemContext } = componentContexts ?? {}

  // papsContext 
  const { pathViews } = paps_state ?? {}

  // golfParentContext
  const golfTournamentContext = useContext(GolfTournamentContext)
  const { golfTournament_state } = golfTournamentContext ?? {}
  const { tournamentGolfers } = golfTournament_state ?? {}

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state, sportsSeason_handlers } = sportsSeasonContext ?? {}
  const { matches_info, roster_info, teams_info, googleLinks_info, roster_gs, roster_gs_home, roster_gs_away, currentSeason_info } = sportsSeason_state ?? {}
  const { currentSeason } = currentSeason_info ?? {}
  const { gls_teams } = googleLinks_info ?? {}
  const { staff, teams } = teams_info ?? {}
  const { rosters: rosters_sport } = roster_info ?? {}
  const { matches, matches_playoffs } = matches_info ?? {}
  const combinedMatches = { ...matches, ...matches_playoffs }

  // sportsMatchContext
  const sportsMatchContext = useContext(SportsMatchContext)
  const { sportsMatch_state } = sportsMatchContext ?? {}

  // sportsRtMatchContext
  const sportsEditMatchContext = useContext(SportsEditMatchContext)
  const { sportsEditMatch_state, sportsEditMatch_handlers } = sportsEditMatchContext ?? {}
  const { match_edit: _currentMatch, currentAthletes } = sportsEditMatch_state ?? {}
  const results = _currentMatch ? _currentMatch._results : undefined;
  const { players: match_athletes } = results ?? {}

  // createSportsContext
  const createSportsContext = useContext(CreateSportsContext);
  const { createSports_state, createSports_handlers } = createSportsContext ?? {}
  const { rosters, selectedAthletes, nominations } = createSports_state ?? {}
  const { handleSet_selectedAthletes } = createSports_handlers ?? {}
  const { levels: level_rosters } = rosters ?? {}

  // uiItemContext 
  const { item_state } = uiItemContext ?? {}
  const { viewItem } = item_state ?? {}
  const { dataSource, key: pageItemKey, display } = viewItem ?? {}
  const { sportsDisplayType } = display ?? {}
  const { subDataGroup } = dataSource ?? {}

  const _sportsDisplayType = sportsDisplayType_prop ? sportsDisplayType_prop : sportsDisplayType

  const _current_match = combinedMatches?.[pathViews.matches]
  const _current_team = teams?.[pathViews.teams]

  const saTypes = {
    athleteOnly: pathViews && (pathViews.athletes || pathViews.tournamentGolfers) ? true : false,
    currentMatchOnly: _current_match && _current_match._itemKey ? true : false,
    hasSports: pathViews && pathViews.sports ? true : false,
    isTournamentTeam: pathViews && pathViews.tournamentTeams ? true : false,
    matchOnly: pathViews && pathViews.matches ? true : false,
    schoolOnly: pathViews && pathViews.schools ? true : false,
    teamOnly: pathViews && pathViews.teams ? true : false,
  }

  const allowBack = useMemo(() => {
    if (!saTypes.currentMatchOnly || !saTypes.teamOnly) {
      return true
    }
  }, [saTypes])

  let forSports = false

  if (saTypes.hasSports && !rosters && !saTypes.athleteOnly && !saTypes.teamOnly && !saTypes.schoolOnly && !saTypes.matchOnly && !saTypes.currentMatchOnly) { forSports = true }


  const [_sportsAthletes, set_sportsAthletes] = useState()
  const [_athletes, set_athletes] = useState()
  const [_staff, set_staff] = useState()
  const [_levelRosters, set_levelRosters] = useState()
  const [_awayAthletes, set_awayAthletes] = useState()
  const [_homeAthletes, set_homeAthletes] = useState()
  const [match_edit, setCurrentMatch] = useState()
  const [selectedTeam, setSelectedTeam] = useState(_current_team)
  const [showMatchRoster, setShowMatchRoster] = useState()
  const [currentMatchRoster, setCurrentMatchRoster] = useState()

  const { filterRosters, updating: updating_roster, allowRosterUpdate, getTeamRosters, updateRoster, getRosters, getStaff } = useTeamRosters()

  const rosters_sport_season = useMemo(() => {
    return filterRosters({ currentSeason, teamRosters: rosters_sport })
  }, [rosters_sport, currentSeason])

  const currentTeams = useMemo(() => {
    if (saTypes.currentMatchOnly) {
      if (_current_match) {
        const { teams: teamKeys } = _current_match
        const filteredTeams = _.pick(teams, teamKeys)
        return filteredTeams
      }
    }
    if (saTypes.teamOnly) {
      if (_current_team) {
        const { _itemKey } = _current_team
        const filteredTeams = _.pick(teams, _itemKey)
        return filteredTeams
      }
    }
    return teams
  }, [saTypes, _current_match, _current_team])


  // sidebar
  const [sidebar_state, sidebar_dispatch] = useReducer(sidebarReducer, sidebarInitialState({ sidebarType, handlers: sportsSeason_handlers }));
  const sidebar_handlers = sidebarHandlers(sidebar_dispatch)
  const { sidebar_items, currents, dimmed } = sidebar_state ?? {}

  const { ms_levels, ms_sections, ms_teams } = sidebar_items ?? {}
  const _levelAthletes = selectedAthletes && ms_levels.selected ? selectedAthletes[ms_levels.selected.item] : null

  let _level_rosters = _levelRosters ? _levelRosters : level_rosters
  if (subActionType === _asat.createAllStarTeams && nominations) { _level_rosters = nominations }

  const useChecker = rosters || _levelAthletes || sportsMatch_state

  useEffect(() => {
    if (match_athletes) {
      sportsEditMatch_handlers.handleSelect_athletes(match_athletes)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [match_athletes]);

  const handleTeamClick = (team) => setSelectedTeam(team)

  const fnAlt_teams = (item) => {
    const _roster_team = rosters_sport_season?.[item?._itemKey]
    const _size = _.size(_roster_team)
    return <Label size='mini' color={_size > 0 ? 'blue' : 'grey'}>{_size}</Label>
  }

  const lbl_icn = (icon, value, width) => <Label size='mini' style={{ flex: 1, width: width ? `${width}px` : '40px', textAlign: 'center' }}>
    <Icon name={icon} color={'blue'} />{value}
  </Label>

  const lbl_icn_check = (value, selected, oc, width) => <Label
    size='mini'
    style={{ flex: 1, width: width ? `${width}px` : '40px', textAlign: 'center' }}
    onClick={(e) => { oc(value) }}
  >
    <Icon
      name={selected ? 'check circle outine' : 'circle outline'}
      color={selected ? 'blue' : 'grey'} />
    {_.startCase(value)}
  </Label>

  const fnAlt_player = (item) => {
    const { graduationYear } = item ?? {}
    return <div style={{ display: 'flex', columnGap: '.5em', justifyContent: 'space-between' }}>
      {lbl_icn('calendar outline', graduationYear, 60)}
    </div>
  }

  const fnAlt_player_select = (item) => {
    const oc = (type) => {
      const _currentMatchRoster = _.cloneDeep(currentMatchRoster)
      const player = _currentMatchRoster[item?.playerKey]
      player[type] = !player[type]
      setCurrentMatchRoster(_currentMatchRoster)
    }
    const { varsity, starter } = item ?? {}
    return <div style={{ display: 'flex', columnGap: '.5em', justifyContent: 'space-between', width: '160px', marginTop: '.5em', marginLeft: '3em' }}>
      {lbl_icn_check('varsity', varsity, oc, 60)}
      {lbl_icn_check('starter', starter, oc, 60)}
    </div>
  }

  const fnSub_player = (item) => {
    const { seasons } = item ?? {}
    const _season = seasons?.[currentSeason]
    const { height, positions } = _season ?? {}
    return <div style={{ display: 'flex', columnGap: '.5em', justifyContent: 'space-between', width: '160px', marginTop: '.5em', marginLeft: '3em' }}>
      {positions && lbl_icn('user', _.join(positions, ','), 60)}
      {height && lbl_icn('user', height, 60)}
    </div>
  }

  const fnPre_player = (item) => {
    const { seasons, graduationYear } = item ?? {}
    const _season = seasons?.[currentSeason]
    const { height, positions, uniformNumber } = _season ?? {}
    return <Label size='mini' color={'blue'} style={{ marginRight: '1em' }}>{uniformNumber}</Label>
  }

  const ims_teams = () => {
    const oc = (item) => {
      const teamRoster = rosters_sport_season?.[item?._itemKey]
      if (!_.isEmpty(teamRoster)) {
        handleTeamClick(item)
      }
    }
    return <Wrapper
      content={<ItemMenuSquares
        menuItems={_.sortBy(currentTeams, 'name')}
        iconItem={'users'}
        fn_altContent={fnAlt_teams}
        onClick={oc}
      />}
      wrapperType={wrapperTypes.padded}
    ></Wrapper>
  }

  const handleShowMatchRoster = (team) => {
    setShowMatchRoster(selectedTeam)
    const _matchRoster = rosters_sport_season?.[selectedTeam?._itemKey]
    const xx = _.pickBy(_matchRoster, ['firstName', 'lastName', 'graduationYear'])
    setCurrentMatchRoster(_matchRoster)
  }

  const handleUpdateMatchRoster = () => {
    console.log('currentMatchRoster', currentMatchRoster)
    setShowMatchRoster()
  }

  const footer_players = () => {
    const btns = []
    btns.push({ caption: 'Select Match Roster', oc: handleShowMatchRoster, color: 'blue', icon: 'arrow right' })
    return <UiSaveButtons others={btns} />
  }

  const footer_players_select = () => {
    const btns = []
    btns.push({ caption: 'Save Match Roster', oc: handleUpdateMatchRoster, color: 'green', icon: 'save' })
    return <UiSaveButtons others={btns} />
  }

  const ims_players = () => {
    const currentPlayerList = rosters_sport_season?.[selectedTeam?._itemKey]
    return <ItemMenuSquares
      imsType={_imsTypes.inline}
      menuItems={_.sortBy(currentPlayerList, 'lastName')}
      fn_altContent={fnAlt_player}
      fn_preContent={fnPre_player}
      fn_subContentt={fnSub_player}
      noItemIcon={true}
      iconItem={'user'}
    />
    // return <Wrapper
    //   header={allowBack && <div style={{ display: 'flex', justifyContent: 'flex-start', columnGap: '1em' }}>
    //     <div><Icon name={'arrow left'} onClick={(e) => { handleTeamClick() }} /></div>
    //     <div>{selectedTeam?.name}</div>
    //   </div>}
    //   content={<ItemMenuSquares
    //     imsType={_imsTypes.inline}
    //     menuItems={_.sortBy(currentPlayerList, 'lastName')}
    //     fn_altContent={fnAlt_player}
    //     fn_preContent={fnPre_player}
    //     fn_subContentt={fnSub_player}
    //     noItemIcon={true}
    //     iconItem={'user'}
    //   />}
    //   footer={footer_players()}
    //   wrapperType={wrapperTypes.padded}
    // ></Wrapper>
  }

  const ims_players_select = () => {
    return <Wrapper
      header={<div style={{ display: 'flex', justifyContent: 'flex-start', columnGap: '1em' }}>
        <div><Icon name={'arrow left'} onClick={(e) => { setShowMatchRoster() }} /></div>
        <div>{`${selectedTeam?.name} Match Roster`}</div>
      </div>}
      content={<ItemMenuSquares
        imsType={_imsTypes.inline}
        menuItems={_.sortBy(currentMatchRoster, 'lastName')}
        fn_altContent={fnAlt_player_select}
        // onClick={oc}
        noItemIcon={true}
        iconItem={'user'}
      />}
      wrapperType={wrapperTypes.padded}
      footer={footer_players_select()}
    ></Wrapper>
  }

  const content = () => {
    if (selectedTeam || saTypes.teamOnly) {
      if (showMatchRoster) {
        return ims_players_select()
      } else {
        return ims_players()
      }
    } else {
      if (saTypes.schoolOnly) {
        return <NoData fullCaption={'Coming Soon...'} />
      } else {
        return ims_teams()
      }
    }
  }

  const fpw = () => <FullPageWrapper
    topperCaption={'Team Rosters'}
    css={{ container: 'app-dark-mode' }}
    handleCancel={handleCancel}
    content={content()}
  />

  return isFullPage ? fpw() : content()

}

export default SportsAthletes 